import type { CommentCommunication } from '@seen/core/models/communications/CommentCommunication'
import { KBD } from '@seen/ui'
import type { JSX } from 'react'
import { useComposeTaskFromComment } from '#src/components/activity/useComposeTaskFromComment.ts'
import { DropdownMenuItem } from '#src/components/core/dropdown-menu/DropdownMenuItem.tsx'

export function DropdownMenuNewTaskFromCommentItem({
  comment,
}: {
  comment: CommentCommunication
}): JSX.Element {
  const composeTaskFromComment = useComposeTaskFromComment(comment)
  return (
    <DropdownMenuItem
      className="flex items-center justify-between gap-4"
      onSelect={composeTaskFromComment}
    >
      <div className="flex items-center gap-2">
        <IconNewTask className="-mt-px size-4 text-foreground-secondary" />
        New task from comment…
      </div>
      <div className="-my-2 flex gap-1">
        <KBD>⌘</KBD>
        <KBD>shift</KBD>
        <KBD>O</KBD>
      </div>
    </DropdownMenuItem>
  )
}

function IconNewTask({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="lch(40% 1 282.863 / 1)"
      role="img"
      focusable="false"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 10.75A4.25 4.25 0 0 0 5.25 15h1a.75.75 0 0 0 0-1.5h-1a2.75 2.75 0 0 1-2.75-2.75v-5.5A2.75 2.75 0 0 1 5.25 2.5h5.5a2.75 2.75 0 0 1 2.75 2.75v.997a.75.75 0 0 0 1.5 0V5.25A4.25 4.25 0 0 0 10.75 1h-5.5A4.25 4.25 0 0 0 1 5.25z"></path>
      <path d="M10.75 14.25a.75.75 0 0 0 1.5 0v-2h2a.75.75 0 0 0 0-1.5h-2v-2a.75.75 0 0 0-1.5 0v2h-2a.75.75 0 0 0 0 1.5h2z"></path>
    </svg>
  )
}
